import type React from 'react';
import { StyleSheet, Text, type TextStyle } from 'react-native';

import { Greys } from '@/ui/common/colors';

const BackButton = ({
  children,
  style,
  ...props
}: {
  children?: React.ReactElement | string;
  style?: TextStyle;
}) => {
  return (
    <Text style={[styles.text, style]} {...props}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  text: {
    color: Greys.shade500,
    fontFamily: 'OpenSans-Regular',
    fontSize: 17,
    fontWeight: '400',
    lineHeight: 17,
    textAlign: 'center',
  },
});

export default BackButton;
